const FormEngineSchema = {
  formName: '',
  menus: [],
  menuOrder: ['fieldsList', 'formBuilder'],
  updateTimestamp: 0,
};

export default FormEngineSchema;
